<!--
 * @Author: ningbo.kang
 * @Date: 2020-01-11 11:38:19
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-06-29 18:05:48
 * @Description: 描述
 -->


<template>
  <a-input v-model="text"
    :data-model="fieldName"
    type="hidden" />
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
};
</script>
